import { observer } from 'mobx-react-lite'
import CustomAlert from '../../../../components/shared/CustomAlert'
import React, { useState } from 'react'
import { MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem } from 'mdb-react-ui-kit'
import UserProfileService from './../../../../shared/services/UserProfile.service'
import UserService from './../../../../shared/services/User.service'
import MDB4DropdownItemButton from '../../../../components/forms/MDB4DropdownItemButton'

const UserActiveButton = ({ onChange }) => {
  const [isLoading, setIsLoading] = useState(false)

  const meetsRequirement =
    UserProfileService.isAssumed() && UserProfileService.isA(['system-admin', 'agency-owner', 'internal-admin'], true)

  const changeIsActive = async active => {
    setIsLoading(true)

    try {
      await UserService.update(UserProfileService.getUserId(), {
        u_active: active,
      })
      UserProfileService.set('u_active', active)
      onChange(true)
      setIsLoading(false)
      UserProfileService.track({
        event_type: 'user.active-status-change.success',
        payload: { u_active: active },
      })
    } catch (error) {
      onChange(error?.message)
      setIsLoading(false)
      UserProfileService.track({
        event_type: 'user.active-status-change.failure',
        event_descrip: error?.message,
      })
    }
  }

  const getLabel = ind => {
    switch (parseInt(ind)) {
      case 1:
        return 'Active'
      case 0:
        return 'Deactivated'
      case -1:
        return 'Protected'
      case -2:
        return 'Blacklisted'
      default:
        return ''
    }
  }

  const getAlert = ind => {
    if (isLoading) {
      switch (parseInt(ind)) {
        case 1:
          return (
            <CustomAlert className='user-active-alert' color='success'>
              Saving Status Change
            </CustomAlert>
          )
        case 0:
          return (
            <CustomAlert className='user-active-alert' color='warning'>
              Saving Status Change
            </CustomAlert>
          )
        case -1:
          return (
            <CustomAlert className='user-active-alert' color='info'>
              Saving Status Change
            </CustomAlert>
          )
        case -2:
          return (
            <CustomAlert className='user-active-alert' color='danger'>
              Saving Status Change
            </CustomAlert>
          )
        default:
          return ''
      }
    }

    switch (parseInt(ind)) {
      case 1:
        return (
          <CustomAlert className='user-active-alert' color='success'>
            Change Account &apos;{getLabel(ind)}&apos; Status
          </CustomAlert>
        )
      case 0:
        return (
          <CustomAlert className='user-active-alert' color='warning'>
            Change Account &apos;{getLabel(ind)}&apos; Status
          </CustomAlert>
        )
      case -1:
        return (
          <CustomAlert className='user-active-alert' color='info'>
            Change Account &apos;{getLabel(ind)}&apos; Status
          </CustomAlert>
        )
      case -2:
        return (
          <CustomAlert className='user-active-alert' color='danger'>
            Change Account &apos;{getLabel(ind)}&apos; Status
          </CustomAlert>
        )
      default:
        return ''
    }
  }

  const renderDropDown = () => {
    const activeAlert = getAlert(UserProfileService.get('u_active'))

    if (meetsRequirement)
      return (
        <div className='user-active-btn'>
          <MDBDropdown dropup className='user-active-dropdown'>
            <MDBDropdownToggle className='dropdown-toggle-caret' color='secondary' type='button'>
              {activeAlert}
            </MDBDropdownToggle>
            <MDBDropdownMenu basic>
              <MDBDropdownItem link childTag={MDB4DropdownItemButton} onClick={() => changeIsActive(1)}>
                <CustomAlert className='user-active-alert' color='success'>
                  ACTIVE
                </CustomAlert>
              </MDBDropdownItem>
              <MDBDropdownItem link childTag={MDB4DropdownItemButton} onClick={() => changeIsActive(0)}>
                <CustomAlert className='user-active-alert' color='warning'>
                  DEACTIVATED
                </CustomAlert>
              </MDBDropdownItem>
              <MDBDropdownItem link childTag={MDB4DropdownItemButton} onClick={() => changeIsActive(-1)}>
                <CustomAlert className='user-active-alert' color='info'>
                  PROTECTED
                </CustomAlert>
              </MDBDropdownItem>
              <MDBDropdownItem link childTag={MDB4DropdownItemButton} onClick={() => changeIsActive(-2)}>
                <CustomAlert className='user-active-alert' color='danger'>
                  BLACKLISTED
                </CustomAlert>
              </MDBDropdownItem>
            </MDBDropdownMenu>
          </MDBDropdown>
        </div>
      )
    return <></>
  }

  return <>{renderDropDown()}</>
}

export default observer(UserActiveButton)
